import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit/types';

interface ITrackPromoBannerProps {
  label: string;
  deviceType: TDeviceType;
  queryString: string;
}

export const getTrackPromoBanner = ({ label, deviceType, queryString }: ITrackPromoBannerProps) => {
  return () =>
    ca('eventSite', {
      name: 'oldevent',
      category: 'mobile_main_page',
      action: 'click_promo',
      label,
      page: {
        pageType: 'Home',
        siteType: deviceType === 'phone' ? 'mobile' : deviceType,
        extra: { queryString },
      },
    });
};
